import { AuditViewDto } from './../../../service/dto';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AgentDto, AuditSessionDto, ResultListDto } from '../../../service/dto';
import { HttpAuditService } from '../../../service/http-audit.service';
import { OnTableChange, TableColumn } from '../../../components/table/table.component';
import { finalize, Observable } from 'rxjs';


@Component({
	selector: 'app-audit-table-views',
	standalone: false,
	templateUrl: './audit-table-views.component.html',
	styleUrl: './audit-table-views.component.scss'
})
export class AuditTableViewsComponent implements OnInit {
	@Input() fetchAudits!: (page: number, pageSize: number) => Observable<ResultListDto<AuditViewDto>>;
	loading = false;
	results?: ResultListDto<AuditViewDto>;
	@Input() downloadHeading!: string;
	@Input() downloadName!: string;


	columnRef: TableColumn[] = [
		{ "title": "When", "cellRef": "date", exportValue: item => item.date },
		{ "title": "Agent Username", "property": "viewedBy.username" },
		{ "title": "Agent Name", "property": "viewedBy.firstName" },
		{ "title": "Agent Surname", "property": "viewedBy.lastName" }
	];

	constructor(private service: HttpAuditService) {

	}
	ngOnInit() {
		this.doFetchResult({ pageIndex: 0, pageSize: 20, filters:[] });
	}


	trackByHashCode(index: number, item: AuditSessionDto): any {
		return item.hashCode;
	}

	doFetchResult(input: OnTableChange) {
		this.loading = true;
		this.fetchAudits(input.pageIndex, input.pageSize)
			.pipe(finalize(() => {
				this.loading = false;
			}))
			.subscribe(result => {
				this.results = result;
			});
	}
}

